import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { MetricCard } from './MetricCard'
import { PlatformOverview } from '../types'
import * as S from '../styles'

interface PlatformOverviewCardsProps {
  data: PlatformOverview
  loading: boolean
}

export const PlatformOverviewCards: React.FC<PlatformOverviewCardsProps> = ({
  data,
  loading
}) => {
  const formatCurrency = (value: number) => {
    if (value >= 1000000000) {
      return 'R$ ' + (value / 1000000000).toFixed(1) + 'B'
    } else if (value >= 1000000) {
      return 'R$ ' + (value / 1000000).toFixed(1) + 'M'
    } else if (value >= 1000) {
      return 'R$ ' + (value / 1000).toFixed(0) + 'K'
    } else {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)
    }
  }

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat('pt-BR').format(value)
  }

  return (
    <S.OverviewCardsContainer>
      <Row>
        <Col lg={3} md={6}>
          <MetricCard
            title="Contratos Totais"
            value={formatNumber(data.totalContracts)}
            subtitle="Contratos criados na plataforma"
            icon="feather icon-file-text"
            color="primary"
            loading={loading}
            change={{
              value: 12.5,
              trend: 'up',
              period: 'último mês'
            }}
          />
        </Col>
        <Col lg={3} md={6}>
          <MetricCard
            title="Valor Total"
            value={formatCurrency(data.totalContractValue)}
            subtitle="Valor total em contratos"
            icon="fa fa-dollar"
            color="success"
            loading={loading}
            change={{
              value: 8.3,
              trend: 'up',
              period: 'último mês'
            }}
          />
        </Col>
        <Col lg={3} md={6}>
          <MetricCard
            title="Transações Blockchain"
            value={formatNumber(data.totalBlockchainTransactions)}
            subtitle="Transações registradas"
            icon="feather icon-link"
            color="info"
            loading={loading}
            change={{
              value: 15.2,
              trend: 'up',
              period: 'último mês'
            }}
          />
        </Col>
        <Col lg={3} md={6}>
          <MetricCard
            title="Usuários Ativos"
            value={formatNumber(data.totalActiveUsers)}
            subtitle="Usuários da plataforma"
            icon="feather icon-users"
            color="warning"
            loading={loading}
            change={{
              value: 5.7,
              trend: 'up',
              period: 'último mês'
            }}
          />
        </Col>
      </Row>
    </S.OverviewCardsContainer>
  )
}
